"use client"

import React, { useState } from 'react';
import { db, ref, set } from '../Firebase/firebase-config'; 
import { v4 as uuidv4 } from 'uuid';
import { FaUser, FaEnvelope, FaPhone, FaCommentDots, FaPaperPlane } from 'react-icons/fa';
import { useAccount } from '../context/AccountContext';
import './NeedHelp.css';

const NeedHelp = () => {
  const { currentAccount } = useAccount();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [step, setStep] = useState(1);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && (isNaN(value) || value.length > 10)) return;
    setFormData({ ...formData, [name]: value });
  };

  const handleNextStep = () => {
    if (step < 4) setStep(step + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // ← THIS IS CRITICAL! Prevents page refresh

    if (!currentAccount) {
      alert('You must be logged in or select an account to submit a request.');
      return;
    }

    // Basic validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      alert('Please fill in all fields before submitting.');
      return;
    }

    try {
      const helpId = uuidv4();
      const newRef = ref(db, `needHelp/${currentAccount.uid}/${helpId}`);
      await set(newRef, {
        ...formData,
        userId: currentAccount.uid,
        timestamp: Date.now()
      });

      alert('✅ Your message has been sent successfully! We\'ll get back to you soon.');
      
      // Reset form
      setFormData({ name: '', email: '', phone: '', message: '' });
      setStep(1);
    } catch (error) {
      console.error('Error sending message:', error);
      alert('❌ Error sending message. Please try again.');
    }
  };

  return (
    <div className="help-container">
      <div className="help-card">
        <h2 className="help-title">How can we help you? 🤔</h2>

        {/* Wrap everything in a <form> and use onSubmit */}
        <form onSubmit={handleSubmit}>
          {step >= 1 && (
            <div className="help-input">
              <FaUser className="help-icon" />
              <input
                type="text"
                name="name"
                placeholder="What's your name?"
                value={formData.name}
                onChange={handleChange}
                required
                onKeyPress={(e) => e.key === 'Enter' && handleNextStep()}
              />
            </div>
          )}

          {step >= 2 && (
            <div className="help-input">
              <FaEnvelope className="help-icon" />
              <input
                type="email"
                name="email"
                placeholder="Your email address?"
                value={formData.email}
                onChange={handleChange}
                required
                onKeyPress={(e) => e.key === 'Enter' && handleNextStep()}
              />
            </div>
          )}

          {step >= 3 && (
            <div className="help-input">
              <FaPhone className="help-icon" />
              <input
                type="tel"
                name="phone"
                placeholder="Your phone number?"
                value={formData.phone}
                onChange={handleChange}
                required
                maxLength="10"
                onKeyPress={(e) => e.key === 'Enter' && handleNextStep()}
              />
            </div>
          )}

          {step >= 4 && (
            <div className="help-input message-box">
              <FaCommentDots className="help-icon" />
              <textarea
                name="message"
                placeholder="Type your message here..."
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
              />
            </div>
          )}

          {step < 4 ? (
            <button type="button" className="next-btn" onClick={handleNextStep}>
              Next ➡️
            </button>
          ) : (
            <button type="submit" className="submit-btn">
              <FaPaperPlane /> Send Help Request
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default NeedHelp;